<script lang="ts">
  interface Props {
    checked?: boolean;
    disabled?: boolean;
    children?: import("svelte").Snippet;
    onClick: () => void;
    onChange: () => void;
  }

  let { checked = false, disabled = false, children, onChange, onClick }: Props = $props();
</script>

<section
  class="transition-colors p-4 duration-200 mb-2 w-full border-2 border-opacity-50 focus-within:border-opacity-100 border-Neutral400 shadow-InputContainer {checked
    ? ' bg-Violet100 border-Violet700'
    : 'bg-Neutral110'} {disabled ? ' pointer-events-none' : ''}"
>
  <label class="cursor-pointer">
    <input onchange={onChange} onclick={onClick} type="checkbox" {checked} class="hidden" />
    {@render children?.()}
  </label>
</section>
